import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from 'client/hooks/useAppSelector';

const LoggedOutRoute: React.FC<{
  component: React.ComponentType;
}> = ({ component: Component }) => {
  const isLoggedIn = useAppSelector(({ auth: { isLoggedIn } }) => isLoggedIn);

  return isLoggedIn ? <Navigate to="/" replace /> : <Component />;
};

export default LoggedOutRoute;
